import store from "../../../../store"
import { Network } from "../../.."
import { ROLE } from "../../../constants"
import { getAdjustedDate } from "../../../helperFunctions"
import APIWrapper from "../../APIWrapper"
import Person from "./Person"
import api from "../../../../../api/axios"
let plans;
const _simpleTypes = (type) => {
	if (type?.includes("HRA")) return "HRA"
	else if (type?.includes("FSA")) return type
}




const getUserModes = ({ user }) => {
	console.log("In legacy getUserModes, user = ", user)
	// bm-note: hi giles, here are the user modes
	const userModes = []
	const availableModes = {}

	if (user?.roles?.length > 0) {
		// console.log("in getUserModes, user roles = ", user.roles)
	}

	if (user.userPlans?.length === 1) {
		availableModes.plans = true

		userModes.push({
			displayValue: `My ${_simpleTypes(user.userPlans[0])}`,
			id: "plans",
			title: `My ${_simpleTypes(user.userPlans[0])}`
		})
	} else if (user.userPlans?.length > 1) {
		availableModes.plans = true

		userModes.push({
			displayValue: "My Accounts",
			id: "plans",
			title: "My Accounts"
		})
	}
	//console.log("in getUserModes, user = ", user)
	if (user.employerAdminEmployer?.id?.length > 0) {
		// console.log("in getUserModes, user.employerAdminEmployer?.id = ", user.employerAdminEmployer?.id)
		availableModes.employer = true
		let displayValue = "Employer";
		if (user?.employerAdminEmployer?.displayName?.length > 15) {
			displayValue = user.employerAdminEmployer?.displayName.substring(0, 13) + "...";
		} else if (user?.employerAdminEmployer?.displayName?.length > 0) {
			displayValue = user.employerAdminEmployer?.displayName;
		}
		// console.log("in getUserModes, displayValue = ", displayValue)
		userModes.push({
			displayValue: displayValue,
			id: "employer",
			title: displayValue
		})
	}
	if (user.isSysAdmin) {
		userModes.push({
			displayValue: `Employers`,
			id: "employers",
			title: "Employers"
		})
		if (user.isPartner) {
			userModes.push({
				displayValue: `Partner`,
				id: "partner",
				title: `Partner`
			})
		}
	} else {
		if (user.isPartner) {
			userModes.push({
				displayValue: `Partner`,
				id: "partner",
				title: `Partner`
			})
		} else if (user.isEmployerAdmin || user.isReferralAccount) {
			userModes.push({
				displayValue: `Employers`,
				id: "employers",
				title: "Employers"
			})
		}
	}



	if (user.roles?.includes(ROLE.SYS_ADMIN)) {
		availableModes.clients = true
		availableModes.ops = true
		availableModes.data = true

		userModes.push({
			displayValue: `Users`,
			id: "users",
			title: "Users"
		})
		userModes.push({
			displayValue: `Ops`,
			id: "ops",
			title: "Ops"
		})

		userModes.push({
			displayValue: `Data`,
			id: "data",
			title: "Data"
		})
	}

	if (user.roles?.includes(ROLE.DEVELOPER) || user.roles?.includes(ROLE.SYS_ADMIN)) {
		availableModes.logs = true
		availableModes.dev = true

		userModes.push({
			displayValue: `Logs`,
			id: "logs",
			title: "Logs"
		})

		userModes.push({
			displayValue: `Dev`,
			id: "dev",
			title: "Dev"
		})
	}
	// console.log("At end of getUserModes, userModes = ", userModes)
	return { userModes, availableModes }
}

export class UserAttributes extends Person {
	constructor(attributes) {
		super(attributes)
	}
}


export class UserInsurance extends APIWrapper {
	static setCoverageFromFormString(string) {
		return {
			self: string.includes("Self") || false,
			children: string.includes("Children") || false,
			spouse: string.includes("Spouse") || false
		}
	}

	get coverageString() {
		return this?.coverage
			? (() => {
				const { self, spouse, children } = this.coverage
				let ret = ""
				if (self) ret += "Self"
				if (spouse) ret += ", Spouse"
				if (children) ret += ", Children"
				return ret
			})()
			: "Not Available"
	}
}

export default class User extends UserAttributes {
	static async get({ user, email, password, login }) {
		// console.log("in User.get, user = ", user)
		let token = ""

		if (user?.token) {
			token = user.token
		} else if (email && password) {
			const url = "user/login"
			const payload = { email, password }
			const response = await Network.AxiosWrapper({ method: "POST", target: url, payload })
			// console.log("in User.get, response = ", response)
			user = response?.data
			token = user?.token
			if (login && !user?.token && user?.use2FA && user?.use2FACodeSentTs && user?.use2FAConfirmedTs) {
				let code = await prompt(`You are enrolled in 2 factor authorization.${user?.use2FAMedium?.toUpperCase()} was sent with an authorization code. Please enter it here.  The code expires in 5 minutes.`);
				console.log("code", code);
				const response = await Network.AxiosWrapper({ method: "POST", target: url, payload: { ...payload, twoFactorAuthCode: code } })
				// console.log("in User.get, response = ", response)
				user = response?.data
				token = user?.token
				if (!token) {
					alert("You entered wrong OTP, login again!");
					window.location.reload();
					return;
				}
			}
		}

		console.log("Getting user profile in User.js");
		const url = "user/v2/profile"
		//		const url = "user/profile"
		const response = await Network.AxiosWrapper({ method: "GET", target: url, token })
		const headers = response.headers

		user = { ...user, ...response?.data }
		// console.log("in User.get, after API call, user = ", user)
		const modes = getUserModes({ user })?.userModes
		// console.log("in User, after getUserModes, modes = ", modes)
		console.log("in User, after getUserModes, user.mode = ", user.mode)

		let mode = user?.mode
		if (!mode?.id) {
			mode = modes?.[0]
		}
		console.log("in User, mode = ", mode, user)
		if (mode?.id === "employer") {
			let employer = null
			let employerId = user?.defaultEmployerAdmin?.employerId || user?.employerAdminEmployer?.id
			if (!employerId) {
				employerId = user?.adminForEmployers?.[0]?.id
			}
			if (employerId) {
				console.log("In User.get, fetching employer with employerId =", employerId);
				console.log("In User.get, User = ", user);
				const url = `employer/${employerId}/profile`
				const response = await Network.AxiosWrapper({ method: "GET", target: url, token })

				employer = response?.data

				if (employer?.id) {
					employer = new Network.API.EmployerNew.Employer({ ...employer, planTypesArray: employer.plans })
				} else {
					employer = {
						id: user.employer?.id,
						name: user.employer?.employerName,
						reimbursementDistributionMethod: user?.employer?.reimbursementDistributionMethod
					}
				}
			}
			console.log("employer---------", employer);
			user.employer = employer
			user.plans = []
		} else if (mode?.id === "plans") {
			const plans = await Network.AxiosWrapper({ method: "GET", target: "user/plan", token })
			user.plans = plans?.data?.data?.map((plan) => new Network.API.Profile.PlanModel(plan))
		}
		if (user.employerAdminEmployer?.id) {
			user.employerAdminEmployer = new Network.API.EmployerNew.Employer({ ...user.employerAdminEmployer })
		}
		// console.log("In User.get, after employer and plans, user = ", user)
		localStorage.setItem("user", JSON.stringify({ ...user, isEmailValidated: true }))
		// console.log("in User.get, login = ", login)

		if (login) {
			const url = "user/plan/openEnrollment"
			const response = await Network.AxiosWrapper({ method: "GET", target: url, token })

			user.pendingEnrollment = response?.data?.data

			// if (user.isPartner) {
			// 	mode = { displayValue: 'Tpa', id: 'tpa', title: 'Tpa' }
			// }
		}
		// console.log("mode setting here giles, user = ", user)
		user = new User({
			...user,
			mode,
			refreshTs: Date.now(),
			login: Boolean(password),
			isLoggedOut: false,
			isIndividual: user?.employer?.name === "Individuals"
		})
		// console.log("in User.get, user = ", user)
		if (headers?.["x-admin-id"]) user.adminUserId = headers["x-admin-id"]
		user.mounted = true
		return user
	}

	static async getUserPlans({
		user,
		params
	}) {
		try {
			const {
				data: { data: planData }
			} = await Network.AxiosWrapper({
				method: "GET",
				target: `employer/${params.employerId}/employee/${params.userId}/plan`,
				token: user.token
			})
			return planData.map((plan) => new Network.API.Profile.PlanModel(plan))
		} catch (err) {
			console.error(err)
		}
	}

	static async getDocuments({ user, params }) {
		//		const plans = params.plans.filter((plan) => plan.type !== "PB")
		const plans = params.plans

		if (plans.length) {
			const responses = await Promise.all(
				plans.map((plan) => {
					const method = plan?.links?.listDocuments?.method
					const target = plan?.links?.listDocuments?.url
					const token = user?.token
					const options = { disablePrefix: true }

					return Network.AxiosWrapper({ method, target, token, options })
				})
			)

			const documents = responses.reduce((documents, response) => {
				return [...documents, ...response?.data?.data]
			}, [])

			return documents
		} else return []
	}

	static async acceptDocuments({
		user,
		params
	}) {
		try {
			if (plans.length > 0) {
				const planDocumentPromise = plans.map((plan) => {
					return Network.AxiosWrapper({
						method: plan.links.acceptDocuments.method,
						target: plan.links.acceptDocuments.url,
						token: user.token,
						options: { disablePrefix: true }
					})
				})
				// const planDocumentData = await Promise.all(planDocumentPromise)
				return []
			} else return []
		} catch (err) {
			console.error(err)
		}
	}

	static async createBaseUser({ data }) {
		try {
			await Network.AxiosWrapperV2.post({ data, url: `user/signup` })
			return true
		} catch (err) {
			console.error(err)
			return false
		}
	}

	static async getAllUsers({ }) {
		try {
			const [
				{
					data: { data: usersData }
				}
			] = await Promise.all([
				Network.AxiosWrapperV2.get({
					url: "user/v2?includeRoles=true"
				})
			])

			const sentTemplates = {}

			const users = new Map()
			usersData.forEach((user) => {
				user.sentTemplates = sentTemplates?.[user.userId]
				users.set(user.userId, new User({ id: user.userId, ...user }))
			})

			return users
		} catch (err) {
			console.error(err)
			return new Map()
		}
	}

	static async getOneUser({ params }) {
		try {
			const [
				{
					data: {
						data: [user]
					}
				}
			] = await Promise.all([
				Network.AxiosWrapperV2.get({
					url: `user/v2?id=${params.id}`
				})
			])
			return new User({ ...user })
		} catch (err) {
			console.error(err)
			return new User({})
		}
	}

	get pagePermissions() {
		const requiresBankAccount = this?.plans.map((plan) => plan?.requiresBankAccount).some((isRequired) => isRequired)

		return {
			profile: {
				bankAccounts: Boolean(requiresBankAccount)
			}
		}
	}

	get rolesString() {
		const roles = []

		if (this?.roles?.includes(ROLE.EMPLOYER_ADMIN)) roles.push("Employer Admin")
		if (this?.roles?.includes(ROLE.QA)) roles.push("QA")
		if (this?.roles?.includes(ROLE.SYS_ADMIN)) if (!this?.lastPasswordChangeTs) roles.push("No Password")

		return roles?.join(", ")
	}

	get fullName() {
		const firstName = this?.firstName
		const lastName = this?.lastName

		if (firstName && lastName) return `${firstName} ${lastName}`
		else if (firstName) return firstName
		else if (lastName) return lastName
		else return ""
	}

	get isSysAdmin() {
		return this?.roles?.includes(ROLE.SYS_ADMIN)
	}

	get isDev() {
		return this?.roles?.includes(ROLE.DEVELOPER)
	}

	get name() {
		if (this?.lastName && this?.firstName) return `${this?.lastName}, ${this?.firstName}`
		else if (this?.lastName) return this?.lastName
		else if (this?.firstName) return this?.firstName
		else return ""
	}

	get currentPlansByType() {
		const currentPlansByType = this?.plans?.reduce((plans, plan) => {
			plan = new Network.API.Profile.PlanModel(plan)
			const planType = plan?.type
			if (plans) {
				if (!plans?.[planType] || plan?.isCurrentPlan) { plans[planType] = plan }
			}
			return plans
		}, {})
		return currentPlansByType || {}
	}

	get currentPlansArray() {
		return Object.values(this?.currentPlansByType)
	}

	get earliestValidPlansByType() {
		const planTypesRequiringInsurance = ["ICHRA", "QSEHRA"];

		const results = (this?.plans || []).reduce((plans, rawPlan) => {
			const plan = new Network.API.Profile.PlanModel(rawPlan);
			const planType = plan?.type;

			// Skip if type is missing
			if (!planType) return plans;

			const insurance = plan?.healthInsurancePending || plan?.healthInsuranceComplete;
			const requiresInsurance = planTypesRequiringInsurance.includes(planType);

			// If insurance is required but not provided, skip this plan
			if (requiresInsurance && !insurance) return plans;

			// If this is the first plan of its type, set it
			if (!plans[planType]) {
				plans[planType] = plan;
				return plans;
			}

			// Compare existing plan with current plan
			const prevPlan = plans[planType];
			const prevFirstDOS = getAdjustedDate({ date: prevPlan?.firstValidDateOfService });
			const currFirstDOS = getAdjustedDate({ date: plan?.firstValidDateOfService });

			// Replace if current plan starts earlier
			if (currFirstDOS < prevFirstDOS) {
				plans[planType] = plan;
			} else {
				// Or if current has insurance but previous didn’t
				const prevInsurance = prevPlan?.healthInsuranceComplete || prevPlan?.healthInsurancePending;
				if (!prevInsurance && insurance) {
					plans[planType] = plan;
				}
			}

			return plans;
		}, {});

		return results;
	}


	get latestValidPlansByType() {
		return this?.plans?.reduce((plans, plan) => {
			plan = new Network.API.Profile.PlanModel(plan)

			const planType = plan?.type
			const planTypesRequiringInsurance = ["ICHRA", "QSEHRA"]

			const healthInsurancePending = plan?.healthInsurancePending
			const healthInsuranceComplete = plan?.healthInsuranceComplete
			const insurance = healthInsurancePending || healthInsuranceComplete // update: needs to be reviewed

			const noInsuranceSubmitted = planTypesRequiringInsurance?.includes(planType) && !insurance

			if (!plans?.[planType]) plans[planType] = plan
			else if (!noInsuranceSubmitted) {
				const prevLastDOS = getAdjustedDate({ date: plans?.[planType]?.lastValidDateOfService })
				const currLastDOS = getAdjustedDate({ date: plan?.lastValidDateOfService })

				if (currLastDOS > prevLastDOS) plans[planType] = plan
			}

			return plans
		}, {})
	}

	get planYearsArrayByType() {
		const planYearsArrayByType = {}

		this?.plans?.forEach((plan) => {
			const formattedPlan = new Network.API.Profile.PlanModel(plan)
			if (planYearsArrayByType[plan.type] === undefined) planYearsArrayByType[plan.type] = []
			planYearsArrayByType[plan.type].push(formattedPlan)
		})

		return planYearsArrayByType
	}

	get plansByEmployerPlanId() {
		const plansByEmployerPlanId = {}

		this?.plans?.forEach((plan) => {
			const formattedPlan = new Network.API.Profile.PlanModel(plan)
			plansByEmployerPlanId[plan?.employerPlanId] = formattedPlan
		})

		return plansByEmployerPlanId
	}

	get plansByUserPlanId() {
		const plansByUserPlanId = {}

		this?.plans?.forEach((plan) => {
			const formattedPlan = new Network.API.Profile.PlanModel(plan)
			plansByUserPlanId[plan?.id] = formattedPlan
		})

		return plansByUserPlanId
	}
	get validPlansByUserPlanId() {
		const plansByUserPlanId = {}

		this?.plans?.forEach((plan) => {
			if (!plan.requiresHealthInsurance || plan.healthInsuranceComplete || plan.healthInsurancePending) {
				const formattedPlan = new Network.API.Profile.PlanModel(plan)
				plansByUserPlanId[plan?.id] = formattedPlan
			}
		})

		return plansByUserPlanId
	}

	get allowTextSubmission() {
		let allowTextSubmission = false
		this?.plans?.forEach((plan) => {
			if (plan?.allowTextSubmission) allowTextSubmission = true
		})
		return allowTextSubmission
	}
	get expenseDatesByPlan() {
		return this?.plans?.reduce((plans, plan, index) => {
			const planType = plan?.type
			const planTypesRequiringInsurance = ["ICHRA", "QSEHRA"]

			const healthInsurancePending = plan?.healthInsurancePending
			const healthInsuranceComplete = plan?.healthInsuranceComplete
			const insurance = healthInsurancePending || healthInsuranceComplete

			const noInsuranceSubmitted = planTypesRequiringInsurance?.includes(planType) && !insurance
			if (!planTypesRequiringInsurance?.includes(planType) || insurance) {
				if (!plans?.[planType]) {
					plans[planType] = {
						startDate: getAdjustedDate({ date: plan?.startDate }),
						endDate: getAdjustedDate({ date: plan?.endDate }),
						firstValidDateOfService: getAdjustedDate({ date: plan?.firstValidDateOfService }),
						lastValidDateOfService: getAdjustedDate({ date: plan?.lastValidDateOfService }),
						lastValidEntryDate: getAdjustedDate({ date: plan?.lastValidEntryDate })
					}
				} else if (!noInsuranceSubmitted) {
					const startDate = getAdjustedDate({ date: plan?.startDate })
					const endDate = getAdjustedDate({ date: plan?.endDate })
					const firstValidDOS = getAdjustedDate({ date: plan?.firstValidDateOfService })
					const lastValidDOS = getAdjustedDate({ date: plan?.lastValidDateOfService })
					const lastValidED = getAdjustedDate({ date: plan?.lastValidEntryDate })

					const prevStartDate = plans?.[planType]?.startDate
					const prevEndDate = plans?.[planType]?.endDate
					const prevFirstValidDOS = plans?.[planType]?.firstValidDateOfService
					const prevLastValidDOS = plans?.[planType]?.lastValidDateOfService
					const prevLastValidED = plans?.[planType]?.lastValidEntryDate

					if (plans[planType]) {
						if (startDate < prevStartDate) plans[planType].startDate = startDate
						if (endDate > prevEndDate) plans[planType].endDate = endDate
						if (firstValidDOS < prevFirstValidDOS) plans[planType].firstValidDateOfService = firstValidDOS
						if (lastValidDOS > prevLastValidDOS) plans[planType].lastValidDateOfService = lastValidDOS
						if (lastValidED > prevLastValidED) plans[planType].lastValidEntryDate = lastValidED
					}
				}
			}

			return plans
		}, {})
	}

	get eligiblePlans() {
		const eligiblePlans = {
			HRA: false,
			FSA: false
		}

		this?.plans?.forEach((plan) => {
			if (plan.type?.includes("HRA")) {
				eligiblePlans.HRA = true
			} else if (plan.type?.includes("FSA")) {
				eligiblePlans.FSA = true
			}
		})

		return eligiblePlans
	}

	get userPlansByTypeNestedMap() {
		const userPlansByTypeNestedMap = {}
		this?.plans?.forEach((plan) => {
			const formattedPlan = new Network.API.Profile.PlanModel(plan)
			if (userPlansByTypeNestedMap[plan.type]) userPlansByTypeNestedMap[plan.type].push(formattedPlan)
			else userPlansByTypeNestedMap[plan.type] = [formattedPlan]
		})
		return userPlansByTypeNestedMap
	}

	get isQaMode() {
		return this?.roles?.includes("qa")
	}

	get modesObject() {
		return getUserModes({ user: this })
	}

	get accountStatus() {
		let accountStatus = { text: this?.status?.short, date: null }
		if (Boolean(this?.inviteOptions?.display)) accountStatus.date = this?.inviteSentTs
		else if (Boolean(this?.employment?.terminationDate)) accountStatus.date = this?.emailValidatedTs
		else if (Boolean(this?.emailValidatedTs)) accountStatus.date = this?.emailValidatedTs

		if (accountStatus.text === "Not Yet Invited" && !this?.plans?.length) {
			accountStatus.text = ""
		}
		return accountStatus
	}

	async update({ params, data }) {
		try {
			await Network.AxiosWrapperV2.post({
				url: `user/${params.id}`,
				data
			})
			store.setNotification("notification", true, {
				msg: `User successfully updated.`,
				severity: "success",
				isPersist: true
			})
			return true
		} catch (err) {
			console.error(err)
			return false
		}
	}

	async logout({ }) {
		// console.log("user.ts: logout")
		try {
			await Network.AxiosWrapperV2.post({
				url: `user/v2/logout`,
				data: { all: true }
			})
			return true
		} catch (err) {
			console.error(err)
			return false
		}
	}

	async deactivate({ }) {
		try {
			await Network.AxiosWrapperV2.post({
				url: `user/${this?.id}/status`,
				data: { isActive: false }
			})
			store.setNotification("notification", true, {
				msg: `Successfully deactivated user: ${this?.email} ${this?.name}.`,
				severity: "success",
				isPersist: true
			})
			return true
		} catch (err) {
			console.error(err)
			return false
		}
	}

	async reactivate({ }) {
		try {
			await Network.AxiosWrapperV2.post({
				url: `user/${this?.id}/status`,
				data: { isActive: true }
			})
			store.setNotification("notification", true, {
				msg: `Successfully reactivated user: ${this?.email} ${this?.name}.`,
				severity: "success",
				isPersist: true
			})
			return true
		} catch (err) {
			console.error(err)
			return false
		}
	}

	async updateRoles({ data }) {
		try {
			await Network.AxiosWrapperV2.post({
				url: `user/${this?.id}/status`,
				data
			})
			store.setNotification("notification", true, {
				msg: `Roles for isQa set to ${data.isQa} for ${this?.name}.`,
				severity: "success",
				isPersist: true
			})
			return true
		} catch (err) {
			console.error(err)
			return false
		}
	}

	async changePassword({ data, params }) {
		const { token, isPasswordRequest, isVerifyPassword, isVerifyAccount } = params

		const url = "user/password"
		await api.post(url, data, { token })

		let message = "Your password has been reset. You will be logged out of all sessions."
		if (isPasswordRequest) message = `An email has been sent to ${this?.email} to change your password.`
		else if (isVerifyPassword) message = "Thank you for verifying your account."

		if (isVerifyAccount) {
			store.setNotification("notification", true, {
				msg: message,
				severity: "success",
				cssSelector: "conversion-trigger"
			})
		} else store.setNotification("notification", true, { msg: message, severity: "success" })

		return true
	}

	async verifyPassword({ params }) {
		try {
			await Network.AxiosWrapperV2.post({
				url: "user/password/verify",
				data: null,
				headers: {
					authorization: params.token
				}
			})
			store.setNotification("notification", true, {
				msg: "Your password has successfully been reset.",
				severity: "success"
			})
			return true
		} catch (err) {
			console.error(err)
			return false
		}
	}

	async changeEmail({
		data,
		params
	}) {
		try {
			await Network.AxiosWrapperV2.post({
				url: `user/email`,
				data,
				headers: {
					authorization: params.token
				}
			})
			let msg = ""
			if (params?.isVerification) msg += "Thank you for verifying your account.\n"
			msg += `An email has been sent to ${this?.email} and ${data.email} to confirm this email change.`
			store.setNotification("notification", true, {
				msg,
				severity: "success"
			})
			return true
		} catch (err) {
			console.error(err)
			return false
		}
	}

	async verifyEmail({ data, params }) {
		try {
			await Network.AxiosWrapperV2.post({
				url: `user/email/verify`,
				data,
				headers: {
					authorization: params.token
				}
			})
			store.setNotification("notification", true, {
				msg: "Your email has successfully been reset. All current sessions will be logged out.",
				severity: "success"
			})
			return true
		} catch (err) {
			console.error(err)
			return false
		}
	}

	async sendInvite({ data }) {
		try {
			await Network.AxiosWrapperV2.post({
				url: `send/invite`,
				data
			})
			store.setNotification("notification", true, {
				msg: `A new verification email has been sent to ${data.email}.`,
				severity: "success"
			})
			return true
		} catch (err) {
			console.error(err)
			return false
		}
	}

	async updateCoverage({ data }) {
		try {
			await Network.AxiosWrapperV2.post({
				url: `user/insurance`,
				data
			})

			return true
		} catch (err) {
			console.error(err)
			return false
		}
	}

	async hraOptOutIn({ data }) {
		try {
			await Network.AxiosWrapperV2.post({
				url: data.isOptIn ? "user/hra/optIn" : "user/hra/optOut",
				data
			})
			data.isOptIn &&
				store.setNotification("notification", true, {
					msg: `You have successfully enrolled into this HRA.`,
					severity: "success"
				})
			return true
		} catch (err) {
			console.error(err)
			return false
		}
	}

	async getSentTemplates({ }) {
		try {
			const {
				data: { data: responseData }
			} = await Network.AxiosWrapperV2.get({
				url: `log/email/?userId=${this?.id}`
			})

			return responseData
		} catch (err) {
			console.error(err)
			return []
		}
	}

	async sendTemplate({ data }) {
		try {
			await Network.AxiosWrapperV2.post({
				url: `marketing/email/${data.id}/user/${this?.userId}`,
				data
			})
			await store.setNotification("notification", true, {
				msg: `Successfully sent email: ${data.name} to ${this?.name}`,
				severity: "success"
			})
			return true
		} catch (err) {
			console.error(err)
			return false
		}
	}

	// account flags

	get isSeanOrCustomer() {
		if (this?.id === "user-gdpki5cmym5m986vsg2v8aow") return true
		else if (this.isSysAdmin || this.isQaMode) return false
		else return true
	}

	get isCustomer() {
		if (this?.isQAMode || this?.isSysAdmin) return false
		else return true
	}

	get allPlansRequiringInsurance() {
		return this?.plans?.filter((plan) => plan?.requiresHealthInsurance)
	}

	get currentPlansRequiringInsurance() {
		return this?.currentPlansArray?.filter((plan) => plan?.requiresHealthInsurance)
	}

	get noInsuranceEntered() {
		if (this?.allPlansRequiringInsurance?.length) {
			return this?.allPlansRequiringInsurance?.every((plan) => plan?.acceptedTs && !plan?.healthInsurance?.length)
		} else return false
	}

	get allPlansWithoutSubmittedInsurance() {
		return this?.allPlansRequiringInsurance?.filter((plan) => {
			const { healthInsurancePending, healthInsuranceComplete } = plan
			return !healthInsurancePending && !healthInsuranceComplete // update: needs to be reviewed
		})
	}

	get currentPlansWithoutSubmittedInsurance() {
		return this?.currentPlansRequiringInsurance?.filter((plan) => {
			const { healthInsurancePending, healthInsuranceComplete } = plan
			return !healthInsurancePending && !healthInsuranceComplete // update: needs to be reviewed
		})
	}

	async bankAccountRequired() {
		const requiresBankAccount = this?.plans?.some((plan) => plan?.requiresBankAccount)
		if (requiresBankAccount) {
			const bankAccounts = await Network.API.Customer.BankAccount.getAll({ options: ["REMOVE_PAYROLL"] })
			return !bankAccounts?.size
		} else return false
	}

	async bankAccountRequiredAllPlans() {
		const requiresBankAccount = this?.plans?.every((plan) => plan?.requiresBankAccount)

		if (requiresBankAccount) {
			const bankAccounts = await Network.API.Customer.BankAccount.getAll({ options: ["REMOVE_PAYROLL"] })
			return !bankAccounts?.size
		} else return false
	}

	async disableExpenseEntry() {
		const today = getAdjustedDate({ date: new Date() })
		const entryDates = this?.plans?.map((plan) => plan?.lastValidEntryDate)
		const allPlansPastEntry = entryDates?.every((date) => today > date)
		if (allPlansPastEntry) return true
		else if (this?.noInsuranceEntered) return true
		else return await this?.bankAccountRequiredAllPlans()
	}

	get closedUserAccount() {
		return !(this?.employer?.id || this?.plans?.length)
	}
}
